import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput)`
  padding: 0 0.5rem;

  && {
    height: 2rem;
  }
`;
